export default [
    {
      path:'/searchFacility',
      name:'SearchFacility',
      component:() => import('./Search')
    }
  ]